import { Component, inject, OnInit } from '@angular/core';
import { RoleService } from '../../../../core/services/role.service';
import { LoaderService } from '../../../../core/shared/services/loader.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { VideosService } from '../../../../core/services/videos.service';
import { VideoCategory } from '../../../../core/models/video.model';
import { BaseComponent } from '../../../../core/shared/base.component';

@Component({
  selector: 'app-academy-categories-management',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './academy-categories-management.component.html',
  styleUrl: './academy-categories-management.component.scss'
})
export class AcademyCategoriesManagementComponent extends BaseComponent implements OnInit  {
  data: VideoCategory[] = [];
  loading = false;
  selected: any = null;
  isNew = false;

  private videoService = inject(VideosService);
  private loader = inject(LoaderService);

  constructor() {
    super();
  }

  ngOnInit() {
    this.load();
  }

  load() {
    this.loading = true;
    this.loader.show();

    this.videoService.getVideoCategories().subscribe({
      next: (response: any) => {
        this.data = response;
        this.loading = false;
        this.loader.hide();
      },
      error: (error) => {
        console.error('Error cargando datos:', error);
        this.loading = false;
        this.loader.hide();
      }
    });
  }

  edit(role: any) {
    this.selected = { ...role };
    this.isNew = false;
  }

  create() {
    this.selected = { name: '', description: '', permissions: [] };
    this.isNew = true;
  }

  save() {
    this.loading = true;
    this.loader.show();

    const saveObservable = this.isNew
      ? this.videoService.createVideoCategory(this.selected)
      : this.videoService.updateVideoCategory(this.selected.id, this.selected);

    saveObservable.subscribe({
      next: () => {
        this.selected = null;
        this.isNew = false;
        this.loader.hide();
        this.load();
      },
      error: (error) => {
        console.error('Error guardando rol:', error);
        this.loading = false;
        this.loader.hide();
      }
    });
  }

  delete(item: any) {
    this.confirm(`¿Está seguro de que desea eliminar la categoría: <strong>${item.name}</strong>?`, "Eliminar categoría", "Si, eliminar")
      .then(res => {
        if (res.isConfirmed) {
          this.loading = true;
          this.loader.show();

          this.videoService.deleteVideoCategory(item.id).subscribe({
            next: () => {
              this.load();
              this.loading = false;
              this.loader.hide();
            },
            error: (error) => {
              console.error('Error eliminando:', error);
              this.loading = false;
              this.loader.hide();
            }
          });
        }
      });

  }

  cancelEdit() {
    this.selected = null;
    this.isNew = false;
  }
}
